import { useState, useEffect, useCallback } from "react";
import { useTenant } from "../../../../hooks/useTenant";
import WorkoutService from "../../../../services/workout_service";
import { toISODate } from "../../../../utils/date";

export const useWorkouts = () => {
    const { idTenant, user: authUser } = useTenant();

    const [selectedDate, setSelectedDate] = useState(toISODate(new Date()));
    const [workouts, setWorkouts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);


    const loadWorkouts = useCallback(async (date) => {
        if (!idTenant || !date) return;
        setLoading(true);
        try {
            const data = await WorkoutService.getWorkoutsByDate(idTenant, date);
            setWorkouts(data || []);
            setError(null);
        } catch (err) {
            setError(err.message || "Erro ao carregar treinos.");
        } finally {
            setLoading(false);
            setIsInitialLoad(false);
        }
    }, [idTenant]);


    useEffect(() => {
        loadWorkouts(selectedDate);
    }, [selectedDate, loadWorkouts]);

    const handleSave = async (formData) => {
        if (!idTenant || !authUser) return;
        setSaving(true);
        try {
            await WorkoutService.save(formData, idTenant, authUser);
            await loadWorkouts(selectedDate);
            return true;
        } catch (err) {
            setError(err.message || "Erro ao salvar treino.");
            return false;
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (workoutId, workoutTitle) => {
        if (!idTenant || !authUser || !workoutId) return;
        setSaving(true);
        try {
            await WorkoutService.delete(workoutId, idTenant, authUser, workoutTitle, selectedDate);
            await loadWorkouts(selectedDate);
            return true;
        } catch (err) {
            setError(err.message || "Erro ao deletar treino.");
            return false;
        } finally {
            setSaving(false);
        }
    };

    const handleDateChange = (newDateStr) => {
        setSelectedDate(newDateStr);
    };

    return {
        selectedDate,
        workouts,
        loading,
        isInitialLoad,
        saving,
        error,
        handleDateChange,
        handleSave,
        handleDelete
    };
};
